import { defineComponent, ref, computed } from 'vue-demi';
import { s as script$2 } from './OrIconButton-5a508869.js';
import { s as script$1 } from './OrIcon-9aff520e.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, renderSlot, createBlock, withModifiers, createCommentVNode } from 'vue';

var NotificationVariant;
(function (NotificationVariant) {
  NotificationVariant["Success"] = "success";
  NotificationVariant["Warning"] = "warning";
  NotificationVariant["Error"] = "error";
  NotificationVariant["Info"] = "info";
})(NotificationVariant || (NotificationVariant = {}));

const Notification = [
// Layout
'layout-row items-start',
// Shape
'rounded-md',
// Spacing
'px-md', 'py-md', 'gap-md',
// Typography
'typography-body-2-regular',
// Typography (children)
'[&_:any-link]:typography-body-2-bold',
// Elevation
'shadow-contextual', 'dark:shadow-contextual-dark',
// Theme
'theme-foreground-default', 'dark:theme-foreground-default-dark'];
const NotificationVariants = {
  [NotificationVariant.Success]: [
  // Theme
  'theme-background-success-container', 'dark:theme-background-success-container-dark',
  // Theme (children)
  '[&_:any-link]:theme-foreground-success', 'dark:[&_:any-link]:theme-foreground-success-dark'],
  [NotificationVariant.Warning]: [
  // Theme
  'theme-background-warning-container', 'dark:theme-background-warning-container-dark',
  // Theme (children)
  '[&_:any-link]:theme-foreground-warning', 'dark:[&_:any-link]:theme-foreground-warning-dark'],
  [NotificationVariant.Error]: [
  // Theme
  'theme-background-error-container', 'dark:theme-background-error-container-dark',
  // Theme (children)
  '[&_:any-link]:theme-foreground-error', 'dark:[&_:any-link]:theme-foreground-error-dark'],
  [NotificationVariant.Info]: [
  // Theme
  'theme-background-primary-container', 'dark:theme-background-primary-container-dark',
  // Theme (children)
  '[&_:any-link]:theme-foreground-primary', 'dark:[&_:any-link]:theme-foreground-primary-dark']
};
const NotificationIcon = [];
const NotificationIconVariants = {
  [NotificationVariant.Success]: [
  // Theme
  'theme-foreground-success', 'dark:theme-foreground-success-dark'],
  [NotificationVariant.Warning]: [
  // Theme
  'theme-foreground-warning', 'dark:theme-foreground-warning-dark'],
  [NotificationVariant.Error]: [
  // Theme
  'theme-foreground-error', 'dark:theme-foreground-error-dark'],
  [NotificationVariant.Info]: [
  // Theme
  'theme-foreground-primary', 'dark:theme-foreground-primary-dark']
};

var script = defineComponent({
  name: 'OrNotification',
  components: {
    OrIcon: script$1,
    OrIconButton: script$2
  },
  props: {
    variant: {
      type: String,
      default: () => NotificationVariant.Info
    },
    disableClose: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-notification-v3', ...Notification, ...NotificationVariants[props.variant]]);
    const iconStyles = computed(() => [...NotificationIcon, ...NotificationIconVariants[props.variant]]);
    // State
    const icon = computed(() => {
      switch (props.variant) {
        case 'success':
          return 'check_circle';
        case 'warning':
          return 'warning';
        case 'error':
          return 'error';
        case 'info':
          return 'info';
      }
    });
    return {
      root,
      rootStyles,
      iconStyles,
      icon
    };
  }
});

const _hoisted_1 = {
  class: /*#__PURE__*/normalizeClass(['mt-[2px] md:mt-[2.5px]'])
};
const _hoisted_2 = {
  class: /*#__PURE__*/normalizeClass(['grow'])
};
const _hoisted_3 = {
  class: /*#__PURE__*/normalizeClass(['mt-[2px] md:mt-[2.5px]'])
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  const _component_OrIconButton = resolveComponent("OrIconButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createElementVNode("div", _hoisted_1, [createVNode(_component_OrIcon, {
    class: normalizeClass(_ctx.iconStyles),
    icon: _ctx.icon,
    variant: 'filled-bold'
  }, null, 8 /* PROPS */, ["class", "icon"])]), createElementVNode("div", _hoisted_2, [renderSlot(_ctx.$slots, "default")]), createElementVNode("div", _hoisted_3, [!_ctx.disableClose ? (openBlock(), createBlock(_component_OrIconButton, {
    key: 0,
    icon: 'close',
    size: 'm',
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.$emit('close'), ["stop"]))
  })) : createCommentVNode("v-if", true)])], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-notification-v3/OrNotification.vue";

export { NotificationVariant as N, script as s };
